import 'css-chunksrc/client/pages/workloadPage/table/projectsDetail/styles.scss';export default {
  "state": "_state_1g7za_1",
  "retry": "_retry_1g7za_16"
};